module.exports = __webpack_public_path__ + "static/media/ecommerce.c31118ec.svg";